
const digest = 'e304c336411f504efe51f5134738669cb5c6f5729cf6f973927ed18865aa32fb';
const classes = {"buttonsWrapper":"_buttonsWrapper_2d8q3_1"};
const css = `._buttonsWrapper_2d8q3_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  